import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "g-swiper-product-image" }
const _hoisted_2 = { class: "g-swiper mt-9" }
const _hoisted_3 = {
  key: 0,
  class: "nav-btn mr-6 mt-[50px] sm:mt-0 z-[999]"
}
const _hoisted_4 = { class: "g-swiper-image-wall flex flex-col sm:space-x-[55px] sm:flex-row" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "wall-4-image ml-4 mt-4 gap-4 sm:ml-0 sm:mt-0 sm:w-[510px]" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "min-h-10" }
const _hoisted_9 = { class: "item__name" }
const _hoisted_10 = { class: "item__brand" }
const _hoisted_11 = { class: "item__price" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT. ", -1)
const _hoisted_13 = {
  key: 0,
  class: "orange-price ml-2 line-through text-light-gary-text-color"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_SwiperNavBtn = _resolveComponent("SwiperNavBtn")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Title, {
      title: '熱銷推薦',
      subTitle: 'Best Seller'
    }),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.recommendedGroups.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_SwiperNavBtn, {
              onPrevClick: _ctx.prevClick,
              onNextClick: _ctx.nextClick
            }, null, 8, ["onPrevClick", "onNextClick"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Swiper, {
        modules: _ctx.modules,
        onSwiper: _ctx.setControlledSwiper,
        autoplay: _ctx.autoPlay,
        navigation: {
          hiddenClass: 'swiper-button-hidden',
          prevEl: 'g-swiper-nav-prev',
          nextEl: 'g-swiper-nav-next',
        }
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendedGroups, (recommendedGroup) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: recommendedGroup.Rank
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "cursor-pointer overflow-hidden px-4 sm:h-auto sm:px-0 sm:basis-[620px]",
                    onClick: ($event: any) => (
                recommendedGroup.Url ?
                _ctx.redirectUrl(recommendedGroup) :
                _ctx.$emit(
                  'goProductList',
                  recommendedGroup.Items[0].RefIdSet.ShopHallCode
                )
              )
                  }, [
                    _createElementVNode("div", {
                      class: "g-image-component hidden sm:block sm:h-auto sm:after:pt-[101.7%] sm:max-w-[620px]",
                      style: _normalizeStyle({
                  backgroundImage:
                    'url(' +
                    recommendedGroup.Image.PcWeb +
                    '?' +
                    _ctx.timestamp +
                    ')',
                })
                    }, null, 4),
                    _createElementVNode("div", {
                      class: "g-image-component sm:hidden after:pt-[60%]",
                      style: _normalizeStyle({
                  backgroundImage:
                    'url(' +
                    recommendedGroup.Image.MobileWeb +
                    '?' +
                    _ctx.timestamp +
                    ')',
                })
                    }, null, 4)
                  ], 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendedGroup.Items, (product, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: product.Rank,
                        class: _normalizeClass(["wall-image-item cursor-pointer", {
                  hidden: index > 1,
                  'sm:block': index > 1,
                }]),
                        onClick: ($event: any) => (_ctx.$emit('goProductDetail', product))
                      }, [
                        _createElementVNode("div", {
                          class: "g-image-component hidden sm:block",
                          style: _normalizeStyle({
                    backgroundImage:
                      'url(' + product.Image.PcWeb + '?' + _ctx.timestamp + ')'
                  })
                        }, null, 4),
                        _createElementVNode("div", {
                          class: "g-image-component sm:hidden",
                          style: _normalizeStyle({
                    backgroundImage:
                      'url(' + product.Image.MobileWeb + '?' + _ctx.timestamp + ')'
                  })
                        }, null, 4),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(product.Name), 1),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(product.SubName), 1),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("span", null, _toDisplayString(product.UnitFeeReal), 1),
                            (product.UnitFeeReal !== product.UnitFeeOri)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                  _hoisted_14,
                                  _createElementVNode("span", null, _toDisplayString(product.UnitFeeOri), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 10, _hoisted_7))
                    }), 128))
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules", "onSwiper", "autoplay"])
    ])
  ]))
}